// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class TradingUnlockMessageResponse extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_TRADING_UNLOCK_MESSAGE_RESPONSE, fieldSet);
    }
    getTradingUnlocked() {
        return this.getFieldValue(FieldsFactory.FIELD_TRADING_UNLOCK_MESSAGE_RESPONSE);
    }
    setTradingUnlocked(unlock) {
        this.setFieldValue(FieldsFactory.FIELD_TRADING_UNLOCK_MESSAGE_RESPONSE, unlock);
    }
}
